import React, { useState } from "react";
import { toast } from "sonner";
import { Eye, EyeOff } from "lucide-react";
import { api } from "@/lib/api";

export function BulkStatementButtons({ ids, onDone }) {
  const [busy, setBusy] = useState(false);

  const apply = async (acik) => {
    setBusy(true);
    try {
      const r = await api.post("/personnel/ekstre-erisim/bulk", { ids, acik });
      toast.success(`${r.data.count} personel için prim ekstresi ${acik ? "açıldı" : "kapatıldı"}`);
      onDone?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Güncellenemedi");
    } finally { setBusy(false); }
  };

  return (
    <>
      <button type="button" data-testid="bulk-statement-open" disabled={busy} onClick={() => apply(true)}
        className="inline-flex items-center gap-1.5 bg-emerald-600 hover:bg-emerald-700 text-white px-3 py-1.5 rounded-lg font-bold uppercase tracking-wider text-[11px] disabled:opacity-50">
        <Eye size={13} /> Ekstre Aç ({ids.length})
      </button>
      <button type="button" data-testid="bulk-statement-close" disabled={busy} onClick={() => apply(false)}
        className="inline-flex items-center gap-1.5 bg-slate-700 hover:bg-slate-800 text-white px-3 py-1.5 rounded-lg font-bold uppercase tracking-wider text-[11px] disabled:opacity-50">
        <EyeOff size={13} /> Ekstre Kapat ({ids.length})
      </button>
    </>
  );
}
